import { Navigate } from "react-router-dom"

// Book Inventory moved to its own procurement menu. Keep the old path working
// for bookmarks and in-app links.
const ItemInventoryContainer = () => <Navigate to="/procurement/book-inventory" replace />

export default ItemInventoryContainer
